import { ReactElement, ReactNode } from "react"

import type { Placement } from "@floating-ui/react"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

import { Tip, TipBubble, TipContentProps, TipTrigger } from "~/src/components/BeeKit/Tip"

export type CueProps = {
  icon?: ReactElement
  tipIcon?: ReactElement
  tip?: ReactNode
  className?: string
  tipProps?: TipContentProps
  children?: ReactNode
  placement?: Placement
}

export function Cue({ children, className, tip, tipProps, icon, placement = "top-start", tipIcon }: CueProps) {
  const { className: tipClassName, ...restProps } = tipProps ?? {}

  return (
    <div className={twMerge("flex items-center gap-1", className)}>
      {icon}
      <p className="text-sm text-nowrap">{children}</p>
      {tip && (
        <Tip placement={placement}>
          <TipTrigger>{tipIcon ? tipIcon : <InformationCircleIcon className="h-4 w-4 text-gray-400" />}</TipTrigger>

          <TipBubble className={twMerge("max-w-xs text-sm", tipClassName)} {...restProps} showArrow={false}>
            {tip}
          </TipBubble>
        </Tip>
      )}
    </div>
  )
}
